import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttDialog, SttFormSelect, SttLabelTitle } from '../../../sporttia/all';

type Option = {
    caption: string;
    value: string;
};

type Props = {
    warningText?: string;
    open?: boolean;
    onAccept?: (mode: string | null) => void;
    onClose?: () => void;
    options?: Option[] | null;
};

/**
 * HandlePaymentsModal: dialog to present options available when deleting existing groups.
 * bool open - modal visibility
 * function onAccept(option) - Callback when 'accept' button is closed. Will be called with currently selected 'mode'
 * function onClose - Callback for closing
 *
 * Note: The option selected in the <select> will be passed as parameter to the onAccept function.
 *       Dialog doesn't close automatically when onAccept is called.
 */
export default function HandlePaymentsModal({
    warningText,
    open = false,
    onAccept,
    onClose,
    options = null,
}: Props): React.ReactElement {
    const { t } = useTranslation();
    const [mode, setMode] = useState<string | null>(null);

    // Render
    return (
        <SttDialog
            open={open}
            onClose={onClose}
            title={t('Collections')}
            content={
                <div>
                    <Box textAlign="center" mb={1}>
                        <SttLabelTitle>{`! ${t('Attention')} !`}</SttLabelTitle>
                    </Box>
                    <Box mb={1}>
                        <Typography variant="body1">{warningText}</Typography>
                    </Box>
                    <SttFormSelect
                        caption={t('SelectOneOption')}
                        defVal={mode}
                        onChange={({ value }: { value: unknown }) =>
                            setMode(value as string)
                        }
                        options={
                            options === null
                                ? [
                                      {
                                          caption: t(
                                              'associatedPayments.doNothing',
                                          ),
                                          value: '0',
                                      },
                                      {
                                          caption: t(
                                              'associatedPayments.refundToPurse',
                                          ),
                                          value: '1',
                                      },
                                      {
                                          caption: t(
                                              'associatedPayments.refundInCash',
                                          ),
                                          value: '2',
                                      },
                                      {
                                          caption: t(
                                              'associatedPayments.delete',
                                          ),
                                          value: '3',
                                      },
                                      {
                                          caption: t(
                                              'associatedPayments.pending',
                                          ),
                                          value: '4',
                                      },
                                  ]
                                : options
                        }
                    />
                </div>
            }
            buttons={[
                {
                    type: 'accept',
                    caption: t('Accept'),
                    onClick: () => onAccept && onAccept(mode),
                    disabled: mode === null,
                },
                {
                    type: 'close',
                    onClick: onClose,
                },
            ]}
        />
    );
}

/*
 associatedPayments.doNothing 	Dejarlos como están 	Leave them as they are 	activar 		activar
6679 	associatedPayments.refundToPurse 	Devolverlos al monedero 	Refund into purse 	activar 		activar
6680 	associatedPayments.refundInCash 	Devolverlos todos al contado 	Refund them in cash 	activar 		activar
6681 	associatedPayments.delete
*/
